export default __webpack_public_path__ + "static/media/audiobooks.e31b179f.svg";